import { RFWebPermissaoEnum } from 'app/shared/auth/permissao/cadastro-menu-routes-permission.config';
import { RouteInfo } from 'app/shared/vertical-menu/vertical-menu.metadata';
// import { ACadastroControleAcessoPermissaoEnum } from './../permissao/RFWebCadastroControleAcessoPermissaoEnum';

export const CADASTRO_USUARIO_GRUPO_MENU_ROUTES: RouteInfo[] = [
  {
    path: '', title: 'Players', icon: 'fa fa-play', id: 21, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioGrupoPlayer,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro-grupo/grupo/player', title: 'Consulta', icon: 'fa fa-object-group', id: 22,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioGrupoPlayer
      },
    ],
  },
]
